import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Col, Popconfirm, Row } from 'antd';
import EditableTable from '../../components/table/EditableTable';
import { getColumnDefs } from "./constants/chartsColumns";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchCharts, sendNotification, updateCharts } from "../../redux/actions";
import { v4 as uuid } from 'uuid';
import _ from 'lodash'

const Charts = () => {
  const dispatch = useDispatch();
  const regulations = useSelector(state => state.config.regulations, shallowEqual);
  const tables = useSelector(state => state.config.tables, shallowEqual);
  const [data, setData] = useState(null);
  const [columnDefs, setColumnDefs] = useState([]);
  const [saving, setSaving] = useState(false);
  const [selectedRows, setSelectedRows] = useState(false);
  const gridAPI = useRef(null);

  const onNew = () => {
    setData(data => [...data, { id: uuid() }]);
  }

  const onSave = () => {
    let valid = true;
    const charts = [];
    gridAPI.current.forEachNode(node => {
      const data = node.data;
      if (!data.label || !data.type || !data.query) {
        valid = false;
        return;
      }
      charts.push(data);
    });
    if (!valid) return dispatch(sendNotification({ type: 'error', message: 'Validation Error', description: 'Label, type and query are required fields' }));
    setSaving(true);
    dispatch(updateCharts(charts)).finally(() => setSaving(false));
  }

  const onDelete = () => {
    const selectedIds = gridAPI.current.getSelectedRows().map(r => r.id);
    setData(data => data.filter(d => !selectedIds.includes(d.id)));
  }

  const fetchData = () => {
    gridAPI.current && gridAPI.current.showLoadingOverlay();
    gridAPI.current && gridAPI.current.paginationGoToFirstPage();
    dispatch(fetchCharts())
      .then(({ payload }) => setData(payload))
      .finally(() => gridAPI.current && gridAPI.current.hideOverlay());
  }

  useEffect(() => {
    const tableOptions = tables.map(r => ({ label: r.label, value: r.name }));
    const regulationOptions = regulations.map(r => ({ label: r.label, value: r.id }));
    setColumnDefs(getColumnDefs({ regulationOptions, tableOptions, onSave, onDelete }));
    fetchData()
  }, []);

  return (
    <div>
      <Row gutter={16}>
        <Col>
          <Button type="primary" onClick={fetchData}>Refresh Table</Button>
        </Col>
        <Col>
          <Button type="primary" onClick={onNew}>Add Row</Button>
        </Col>
        <Col>
          <Button type="danger" onClick={onDelete} disabled={!selectedRows}>Delete Row</Button>
        </Col>
        <Col>
          <Popconfirm
            title="Are you sure to save this table?"
            onConfirm={onSave}
            okText="Yes"
            disabled={saving}
          >
            <Button type="primary" disabled={saving}>Save Table</Button>
          </Popconfirm>
        </Col>
      </Row>
      <EditableTable
        rowData={data}
        columnDefs={columnDefs}
        defaultColDefs={{
          editable: true,
          filter: true,
          floatingFilter: true
        }}
        setAPI={(api) => gridAPI.current = api}
        onSelectionChanged={() => setSelectedRows(!!gridAPI.current.getSelectedRows().length)}
      />
    </div>
  );
}

export default Charts;
